import React, {useEffect, useState} from 'react';
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useDispatch, useSelector } from 'react-redux';
import {Link, useHistory} from "react-router-dom";
import { get_all_groups } from '../../../redux/users';

const GroupList = (props) => {
    let history = useHistory();

    const dispatch = useDispatch();
        
    const { token } = useSelector((state) => state.users_module.login.data)||null;

    useEffect(() => {
        dispatch(get_all_groups(token));
    }, [dispatch, token]);
    
    const _get_all_groups = useSelector(
        (state) => state.users_module._get_all_groups
    );
    const [data, setData] = useState([]);
    useEffect(() => {
        if (_get_all_groups.data.datos) {
            setData(_get_all_groups.data.datos);
        }
    }, [_get_all_groups]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);


    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);

        }
    }, [props]);


    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_group').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "primary",
                    onClick: (item) => {
                        history.push(`/roles/editar/${item.id}`);
                    },
                })

            }
        }
        setActions(act);
    }, [permisos, history]);


    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Roles"
                            items={[{label: "Roles", link: "/roles"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_group').length > 0 ?
                                        <Link to="/roles/crear" className="btn btn-success">
                                            Crear
                                        </Link> : null
                                }

                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },


                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default GroupList;
